import type { ReactNode } from 'react';

export type TopBarProps = {
  title: string;
  subtitle?: string;
  left?: ReactNode;
  right?: ReactNode;
};

export function TopBar({ title, subtitle, left, right }: TopBarProps) {
  return (
    <header className="flex h-16 shrink-0 items-center justify-between gap-4 border-b border-[var(--border-subtle)] bg-[var(--bg)] px-6">
      <div className="flex min-w-0 items-center gap-4">
        <div className="min-w-0">
          <h1 className="m-0 truncate text-lg font-semibold">{title}</h1>
          {subtitle && <p className="m-0 truncate text-sm text-[var(--text-muted)]">{subtitle}</p>}
        </div>
        {left}
      </div>
      <div className="flex items-center gap-3">{right}</div>
    </header>
  );
}
